import { render, staticRenderFns } from "./AppChatMessage.vue?vue&type=template&id=7bba3187&scoped=true"
import script from "./AppChatMessage.vue?vue&type=script&lang=js"
export * from "./AppChatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba3187",
  null
  
)

export default component.exports